import * as API from '@/services/API'

export default {
    getAides(payload: any) {
        return API.apiClient.get(`/parameters/aides`, { params: payload })
    }
}
